module.exports = __webpack_public_path__ + "img/step2.1f14e748.png";